import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getJobHeads } from "./Axios";

const HeadsSelect = props => {
  const [heads, setHeads] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "head");
  };

  useEffect(() => {
    getJobHeads((response) => {
      if (response && response.data) {
        const newHeads = response.data.map((head) => ({
          value: head.id,
          label: head.name,
          uniqueIdentifier: head.unique_identifier,
          email: head.email,
        }));
        setHeads(newHeads);
      }
    });
  }, []);

  return (
    <Select
      inputId="head"
      onChange={handleChange}
      options={heads}
      placeholder="Buscar y seleccionar una Jefatura"
      value={
        heads.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label} (${e.uniqueIdentifier}) (${e.email}) `}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label, uniqueIdentifier } = option.data;
        return (
          label.toLowerCase().includes(searchTerm) ||
          uniqueIdentifier.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default HeadsSelect;

